<script lang="ts" setup>
import { useUserProfile } from '@auth/useProfile';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import type { MenuItemCommandEvent } from 'primevue/menuitem';
import VAvatar from '@shared/component/VAvatar/VAvatar.vue';
import VMenu from '@shared/component/VMenu/VMenu.vue';
import { navigateToUrlWithPostRequest } from '@tools/helpers';
import { ref } from 'vue';
import { useFeatureToggle } from '@environment/useFeatureToggle';
import { tryMenuNavigation } from '../../urlHelper';

const props = withDefaults(
  defineProps<{
    alwaysSmall?: boolean;
    iconStyle?: string;
  }>(),
  { iconStyle: 'far' },
);

const menu = ref<InstanceType<typeof VMenu>>();
const nieuwDashboard = useFeatureToggle('NieuwDashboardToggle');

const { userProfile, userProfileIsPending } = useUserProfile();

function toggleMenu(event: Event) {
  menu.value?.toggle(event);
}
</script>

<template>
  <div class="relative flex">
    <button
      title="Account"
      class="flex cursor-pointer items-center gap-1 border-none bg-transparent px-4 text-sm text-inherit outline-none"
      :class="{
        'lg:px-6': !props.alwaysSmall,
      }"
      type="button"
      @click="toggleMenu"
    >
      <FontAwesomeIcon :icon="[props.iconStyle, 'cog']" />
      <span
        v-if="!nieuwDashboard"
        class="hidden"
        :class="{
          'xl:display-unset': !props.alwaysSmall,
        }"
      >
        Account
      </span>
    </button>

    <VMenu
      append-to="self"
      class="!left-auto !right-0 !top-full"
      :model="[
        {
          command: ({ originalEvent }: MenuItemCommandEvent) =>
            tryMenuNavigation(originalEvent, '/identity/user/account?returnUrl=%2Fcontent%2F'),
          icon: ['far', 'user'],
          label: 'Account',
          url: '/identity/user/account?returnUrl=%2Fcontent%2F',
        },
        {
          command: ({ originalEvent }: MenuItemCommandEvent) =>
            tryMenuNavigation(originalEvent, '/content/beheer/tussenpersoon'),
          icon: ['far', 'cog'],
          label: 'Instellingen',
          url: '/content/beheer/tussenpersoon',
        },
        {
          command: ({ originalEvent }: MenuItemCommandEvent) => {
            originalEvent.preventDefault();
            navigateToUrlWithPostRequest('/Identity/Authentication/Logout');
          },
          icon: ['far', 'right-from-bracket'],
          label: 'Uitloggen',
        },
      ]"
      popup
      ref="menu"
    >
      <template #start>
        <div
          v-if="!userProfileIsPending"
          class="grid grid-cols-[auto_1fr] grid-rows-2 gap-x-3 border-0 border-b border-solid border-grey-200 p-4"
        >
          <VAvatar class="row-span-2 self-center" :name="userProfile!.fullName" />

          <span class="flex items-end text-sm text-primary-900">
            {{ userProfile!.fullName }}
          </span>

          <span class="text-xs text-grey-400">
            {{ userProfile!.tussenPersoon }}
          </span>
        </div>
      </template>
    </VMenu>
  </div>
</template>
